import RefundFlightInfo from '../Refund/FlightInfo'

class FlightInfo extends RefundFlightInfo {
    constructor(domElement = null) {
        super(domElement)
    }
}

export default FlightInfo
